/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import { apiHelpers } from 'ui-lottery/src/api/helpers';
import * as endpoints from './endpoints';

const { get, getWithAuth, postWithAuth, putWithAuth } = apiHelpers(SecurityHelper);

// Reservations
export const getReservation = (resId) =>
    getWithAuth(endpoints.reservationEndpoint(resId));
export const getReservations = () => getWithAuth(endpoints.reservationsEndpoint());
export const createReservation = (res) =>
    postWithAuth(endpoints.reservationsEndpoint(), res);
export const createReservations = (res) =>
    postWithAuth(endpoints.reservationsV2Endpoint(), res);
export const updateReservation = (res) =>
    putWithAuth(endpoints.reservationEndpoint(res.id), res);

// Pass Types
export const getPassTypes = () => get(endpoints.passTypesEndpoint());
export const getPassType = (passId) => get(endpoints.passTypeEndpoint(passId));

// Pass Series
export const getPassSeries = (id) => get(endpoints.seriesEndpoint(id));

// Address
export const verifyAddress = (address) =>
    postWithAuth(endpoints.verifyAddressEndpoint(), address);
